import axios from 'axios';

const hostName = window.location.hostname;
let url = 'https://fmedway.com.br/wp-json/acf/v3/';

switch (hostName) {
  case 'extensivo.medway.com.br':
    url = 'https://extensivo.medway.com.br/wp-json/acf/v3/';
    break;
  default:
    break;
}

const apiExtensivo = axios.create({
  baseURL: url,
});

export default apiExtensivo;
